// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EditableTextArea_Wrapper__3RCUd","TextArea":"EditableTextArea_TextArea__1qZS_","Pincode":"EditableTextArea_Pincode__3YstR"};